import React, { useEffect } from 'react';
import Type from 'prop-types';
import { Doughnut, Chart } from 'react-chartjs-2';

function drawDonutLabel(chart, options) {
  const { ctx } = chart.chart;
  const { text } = chart.config.data;
  const { font } = options;

  ctx.font = `${font.size}${font.unit} ${font.family}`;
  ctx.fillStyle = font.color;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
  const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

  ctx.fillText(text, centerX, centerY);
}

const Donut = props => {
  const { data, options, font, ...other } = props;

  useEffect(() => {
    Chart.plugins.register({
      id: 'doughnutlabel',
      beforeDatasetDraw(chart) {
        const chartOptions = { font };
        drawDonutLabel(chart, chartOptions);
      },
    });
  }, [font]);

  return <Doughnut data={data} options={options} {...other} />;
};

Donut.propTypes = {
  data: Type.oneOfType([Type.object, Type.func]).isRequired,
  options: Type.object, // eslint-disable-line react/forbid-prop-types
  font: Type.shape({
    family: Type.string,
    size: Type.number,
    unit: Type.string,
    lineHeight: Type.number,
    color: Type.string,
  }),
};

Donut.defaultProps = {
  options: {},
  font: {
    family: '"Roboto", "Helvetica", "Arial", sans-serif',
    size: 3.75,
    unit: 'rem',
    lineHeight: 1,
    color: '#263238',
  },
};

export default Donut;
